import React, { Component, CSSProperties } from 'react';
import styles from '../index.css';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import { RenderPostionType } from '../../../../../js/constant';
import PopupWrapper, { PopupMenuType } from '@com-pc/popup-wrapper';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { IReactionDisposer, reaction } from 'mobx';
import AnimationIcon from '@src/framework/frame/components/animation-editor/images/animation_icon.svg';
import { CUSTOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import slideLoading from '@src/img/first-screen/slide-loading.svg';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import type { PPTEditorStateTypeValue } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { getSlideWidthDiff } from '@com/pc-left-thumbnail-list/utils';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import {
    TimingPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/page/timing-property-converter';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { ISlideComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/types';
import {
    SLIDE_RENDER_ENTRY,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { REPORT_LOCATION } from '@src/slide/application/service/ai-replace-slide/ai-replace-slide-service.interface';
import { findDOMNode } from 'react-dom';
import CommentAnchor from '@src/framework/editor/src/page/index/components/canvas/edit-panel/components/comment-border/components/comment-anchor';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { SlideExtraButtons } from '@src/framework/frame/components/pc-left-thumbnail-list/add-slide-card/slide-extra-buttons';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';

interface SlideListCellProps {
    motionStyle: {
        zIndex: number; translateX: number; translateY: number; scale: number, left: number, position: any };
    position?: CSSProperties['position'];
    draging: boolean;
    slideWidth: number;
    slideHeight: number;
    slideInnerHeight: number;
    isSelected: boolean;
    cellIndex: number;
    showSpecialOutline: boolean;
    shouldContentUpdate: boolean;
    slideModel: ISlideModel;
    lockInfo: any;
    renderCellIndex: number;
    clearanceIndex: number;
    isShowInPlay?: boolean;
}

interface SlideListCellState {
    timingChanged: number;
    canvasDidRender: boolean;
    editorState: PPTEditorStateTypeValue;
    forceNotShow: boolean;
    commentCount: number;   // 批注组个数
    isOutSlideListViewer: boolean;
}

class SlideListCell extends Component<SlideListCellProps, SlideListCellState> {
    private timingAutorun: IReactionDisposer;
    private preloadAction: IReactionDisposer;
    private viewableReaction?: IReactionDisposer;
    private canvasConainerDivRef: HTMLElement|null;
    private domRef: HTMLElement|null;
    private innerDomRef: HTMLElement|null;
    private hasRendered = false;
    private unregisterEditorStateEvent: Function;

    public constructor(props) {
        super(props);

        const initEditorState = this.getUserPriviledgeService()?.pptEditorState;

        this.state = {
            timingChanged: 0,
            canvasDidRender: false,
            editorState: initEditorState,
            forceNotShow: false,
            commentCount: this.props.slideModel.commentGroupInfoMap?.size ?? 0,
            isOutSlideListViewer: false,
        };

        // 可视区域变化后，更新视图是否在视图内
        this.viewableReaction = reaction(() => {
            const { viewableServiceLayer } = this.getAppServices();
            return viewableServiceLayer.slideRenderStateManager?.getVisibleSlideKeyList().slice();
        }, (visibleSlideKeyList) => {
            const isOutSlideListViewer = !visibleSlideKeyList.includes(this.props.slideModel.key);
            this.setState({
                isOutSlideListViewer,
            });
            if (!isOutSlideListViewer) {
                this.updateCommentCount();
            }
        });

        this.timingAutorun = reaction(() => (
            {
                timing: this.props.slideModel.timing,
                length: this.props.slideModel.animList.length,
            }
        ), () => {
            const timingChanged = this.state.timingChanged + 1;
            this.setState({
                timingChanged,
            });
        }, { fireImmediately: false });
        this.preloadAction = reaction(
            () => props.slideModel.preload,
            () => this.setState({}),
        );

        this.unregisterEditorStateEvent = this.getUserPriviledgeService()?.onPPTEditorStateChange((editorState) => {
            this.setState({
                editorState,
            });
        });

        eventBus.on(EventKeys.COMMENT_GROUP_INFO_CHANGED, this.updateCommentCount);
        props.slideModel?.changeSetEngine?.addObserveForChangeAtPath('commentGroupMap', this.updateCommentCount);
    }

    public componentWillUnmount() {
        if (this.timingAutorun) {
            this.timingAutorun();
        }
        this?.preloadAction?.();
        this.viewableReaction?.();

        this.unregisterEditorStateEvent?.();

        eventBus.off(EventKeys.COMMENT_GROUP_INFO_CHANGED, this.updateCommentCount);
        this.props.slideModel?.changeSetEngine?.removeObserveForChangeAtPath('commentGroupMap', this.updateCommentCount);
    }

    public componentDidMount() {
        eventBus.emit(EventKeys.SLIDE_LIST_CELL_MOUNTED, this.props.slideModel);
    }

    public render() {
        return this.props.slideModel.isSlide
            ? (<PopupWrapper index={this.props.clearanceIndex} type={PopupMenuType.SLIDE} style={{ display: 'flex' }}>{this.renderSlide()}</PopupWrapper>)
            : (<PopupWrapper index={this.props.clearanceIndex} type={PopupMenuType.LAYOUT_MASTER} style={{ display: 'flex' }}>{this.renderSlide()}</PopupWrapper>);
    }

    public cloneDom = (cloneDeep) => {
        const deep = typeof (cloneDeep) === 'undefined' ? true : cloneDeep;
        const outer = this.domRef?.cloneNode(false);
        let inner = this.innerDomRef?.cloneNode(deep);
        if (this.canvasConainerDivRef) {
            // 缩略图可能有多个canvas，拿到所有canvas的父节点，按序将子canvas节点drawImage到clone的canvas上
            // todo：列表接缓存后，拖拽时把所有canvas绘到一个canvas上即可
            inner = this.canvasConainerDivRef.cloneNode(deep);
            const originCanvasList = this.canvasConainerDivRef.querySelectorAll('canvas') || [];
            const cloneCanvasList = (inner as HTMLElement).querySelectorAll('canvas') || [];

            // 多选时不需要处理被覆盖的缩略图，因此inner的children是空的，不需要遍历，给个背景色即可
            cloneCanvasList.forEach((cloneCanvasDom, index) => {
                const originCanvasDom = originCanvasList[index];
                const cloneCanvas2d = cloneCanvasDom.getContext('2d');
                cloneCanvas2d?.drawImage(originCanvasDom, 0, 0);
            });
            (inner as HTMLElement).style.background = '#FFFFFF';
        }
        if (inner) {
            (inner as HTMLElement).style.boxShadow = '1px 1px 4px 0 rgba(0, 0, 0, 0.1)';
            (inner as HTMLElement).style.outline = '1px solid rgba(0,0,0,0.06)';
            outer?.appendChild(inner);
        }
        return outer;
    };

    public setForceHidden = (forceNotShow: boolean) => {
        if (this.innerDomRef) {
            // eslint-disable-next-line react/no-find-dom-node
            const dom = findDOMNode(this.innerDomRef);
            if (!dom) return;
            (dom as HTMLElement).style.display = forceNotShow ? 'none' : 'block';
        }
    };

    private updateCommentCount = () => {
        if (this.state.isOutSlideListViewer) return;
        const commentGroupSize = this.props.slideModel.commentGroupMap?.size ?? 0;
        const commentGroupInfoSize = this.props.slideModel.commentGroupInfoMap?.size ?? 0;
        // case: 删除全部批注后撤销。为避免撤销后重复拉取批注的问题，commentGroupInfoMap会缓存数据
        if (commentGroupSize === 0) {
            this.setState({ commentCount: commentGroupSize });
        } else {
            this.setState({ commentCount: commentGroupInfoSize });
        }
    };

    private showAnimation = () => {
        this.getRightSideBarManager()?.setIsAnimationEditorShown(true);
        this.getSelectionService().currentSlide?.convertAnimDataSdkToUi();
    };

    private getSelectionService() {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getRightSideBarManager = () => this.getAppServices().editableServiceLayer?.rightSideBarManager;

    private getUserPriviledgeService() {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }

    private getMasterLayoutEditService() {
        return this.getAppServices().editableServiceLayer?.masterLayoutEditService;
    }

    private getMasterLayoutStyleService() {
        return this.getAppServices().viewableServiceLayer.masterLayoutStyleService;
    }

    private getAIController() {
        return this.getAppServices().editableServiceLayer?.aiController;
    }

    private getAIReplaceSlideService() {
        return this.getAppServices().editableServiceLayer?.aiReplaceSlidePCService;
    }

    private getAIAssistantService() {
        return this.getAppServices().editableServiceLayer?.aiAssistantService;
    }

    private getUiDataService() {
        return this.getAppServices().getUiDataService();
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    /**
     * 获取scale-slide里，所有canvas的父节点
     * @param divElement
     */
    private setCanvasContainerRef = (divElement) => {
        this.canvasConainerDivRef = divElement;
    };

    private getOffsetY() {
        return 0;
    }

    private onDidRenderCallback = (slideComponent: ISlideComponent) => {
        if (!this.hasRendered && slideComponent?.hasBuild && !this.props.slideModel.preload) {
            this.hasRendered = true;
            this.setState({ canvasDidRender: true });
        }
        this.getAppServices().viewableServiceLayer.slideRenderStateManager
            .setSlideRenderCompleted(slideComponent, SLIDE_RENDER_ENTRY.THUMBNAIL_PC);
    };

    private renderSlide() {
        return (
            <div
                style={{
                    zIndex: this.props.motionStyle.zIndex,
                    position: 'relative',
                    width: this.props.slideWidth,
                    height: this.props.slideHeight,
                    left: this.props.motionStyle.left,
                }}
                ref={(el) => {
                    this.domRef = el;
                }}
            >
                { this.renderSlideIndex() }
                { this.renderAnimationIcon() }
                { this.renderCommentInfo() }
                { this.renderSlideWrapper() }
            </div>
        );
    }

    /**
     * 渲染幻灯片索引
     * @returns
     */
    private renderSlideIndex() {
        const { slideModel, isSelected, draging, renderCellIndex } = this.props;
        if (slideModel.isLayout) return null;
        const { selectedOpacity, opacity: unselectedOpacity } = this.getMasterLayoutStyleService()
            .getCurSlideIndexStyle();
        // eslint-disable-next-line no-nested-ternary
        const opacity = draging ? '0.24' : isSelected ? selectedOpacity : unselectedOpacity;
        return (
            <span className={styles.slideIndex}
                style={{
                    opacity,
                }}
            >{renderCellIndex + 1}</span>
        );
    }

    /**
     * 渲染动画角标
     * @returns
     */
    private renderAnimationIcon() {
        if (this.state.editorState !== PPTEditorStateType.EDITABLE) return null;
        if (this.getMasterLayoutEditService()?.isMasterEditType) return null;
        const { timing } = this.props.slideModel;
        const hasAnim = TimingPropertyConverter.checkHasAnim(timing);
        if (!hasAnim) return null;
        return (<img className={styles.animationIcon} onClick={this.showAnimation} src={AnimationIcon} />);
    }

    /**
     * 渲染批注角标
     */
    private renderCommentInfo() {
        if (this.getAppServices().viewableServiceLayer.commentManager.dangerousInstance?.shouldHideComment()
            || !getCacConfigByKey('feature.comment', false)
            || !this.state.commentCount) return null;
        return <CommentAnchor
            count={this.state.commentCount}
            isLeftCell={true}
            commentManager={this.getAppServices().viewableServiceLayer.commentManager}
        />;
    }

    /**
     * 渲染幻灯片外壳
     * @returns
     */
    private renderSlideWrapper() {
        const left = getSlideWidthDiff(this.getUiDataService());
        const maskStyle: CSSProperties = {};
        const style: CSSProperties = {
            background: '#FFFFFF',
            boxShadow: '0 0 6px 0 rgba(0,0,0,0.04)',
            outline: this.props.showSpecialOutline ? '2px solid rgba(30, 111, 255, 1)' : '1px solid rgba(0,0,0,0.06)',
            filter: this.props.draging ? 'opacity(0.24)' : undefined,
            top: '0px',
            bottom: '0px',
            width: '100%',
            display: 'block',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            position: 'absolute',
            left: `${left}px`,
            borderRadius: 4,
        };
        if (this.props.slideModel.isLayout) {
            const styleService = this.getMasterLayoutStyleService();
            const { transformScale, transformOrigin } = styleService.getLayoutCanvasWrapperStyle();
            maskStyle.transform = `scale(${transformScale})`;
            maskStyle.transformOrigin = transformOrigin;
        }
        return (
            <div
                className={styles.slideWrapperMask}
                style={maskStyle}
            >
                <div
                    className={styles.slideWrapper}
                    style={style}
                    ref={(el) => {
                        this.innerDomRef = el;
                    }}
                >
                    {this.renderHideStatus()}
                    {this.renderScaleSlide()}
                    {this.renderLockContainer()}
                </div>
                {this.renderExtraButtons(this.props.slideModel, this.props.isSelected)}
            </div>
        );
    }

    /**
     * 渲染幻灯片快捷功能，例如添加页面
     */
    private renderExtraButtons(slideModel: ISlideModel, isSelected) {
        if (!getToggleStatusByType(ToggleType.AI_REPLACE_SLIDE)) {
            return <></>;
        }
        if (!slideModel.isSlide) {
            return <></>;
        }
        if (
            !this.getAIController()?.checkIsSupportAIEdit()
            || !this.getAppServices().viewableServiceLayer.userPriviledgeService.isEditable()
        ) {
            return <></>;
        }
        const innerDomBounding = this.innerDomRef?.getBoundingClientRect();
        const x = innerDomBounding && innerDomBounding.right + 24;
        const y = innerDomBounding?.top;
        if (isSelected && slideModel.id === this.getSelectionService().currentSlide?.id) {
            this.getAIReplaceSlideService()?.promise()
                .then(s => s.setDefaultPosition(x, y));
        }
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_BEAUTY,
            action: TDWActionType.VIEW,
            ver5: TDWModuleType.PC,
            ver6: REPORT_LOCATION.slideList,
        });
        return (
            <SlideExtraButtons
                aiReplaceService={this.getAIReplaceSlideService()?.promise()}
                className={styles.extraButtons}
            />
        );
    }

    private renderHideStatus() {
        const { slideModel } = this.props;
        if (!slideModel.isShowInPlay) {
            return (
                <>
                    <div className={styles['hide-icon']} />
                    <div className={styles['hide-mask']} />
                </>
            );
        }
    }

    /**
     * 渲染幻灯片主要区域
     * @returns
     */
    private renderScaleSlide() {
        const shouldRenderSlideCanvas = this.props.slideModel.sdkData // 有数据
            && !this.props.slideModel.preload // 不是在预加载状态
            && !this.state.forceNotShow; // 强制不渲染，用于列表不在可视区域时
        const shouldShowSlideCanvas = shouldRenderSlideCanvas && this.state.canvasDidRender;
        const { isOutSlideListViewer } = this.state;

        return (
            <React.Fragment>
                {
                    // 目前看起来，加载后没有必要保留占位图，缩略图不回收，占位图之后也不太可能显示了，display虽然摘树了，但还是在内存里
                    !shouldShowSlideCanvas && <img src={slideLoading}
                        style={{
                            padding: '12px',
                            width: '100%',
                            height: '100%',
                            boxSizing: 'border-box',
                            // display: shouldShowSlideCanvas ? 'none' : 'block',
                        }}
                    />
                }
                {
                    this.props.slideModel.childrenConverted && <ScaleSlide
                        needDisposeAppAndKeepCanvas={isOutSlideListViewer}
                        styles={{
                            scaleSlideStyle: {
                                opacity: shouldShowSlideCanvas ? 1 : 0,
                                transition: 'opacity 0.2s',
                            },
                        }}
                        width={this.props.slideWidth}
                        height={this.props.slideInnerHeight}
                        slideModel={this.props.slideModel}
                        shouldUpdate={this.props.shouldContentUpdate}
                        region={RenderPostionType.LEFTLIST}
                        setCanvasContainerRef={this.setCanvasContainerRef}
                        onDidRenderCallback={this.onDidRenderCallback}
                    />
                }
            </React.Fragment>
        );
    }

    /**
     * 渲染锁页框
     * @returns
     */
    private renderLockContainer() {
        const { lockInfo } = this.props;
        if (!lockInfo) return null;
        return (
            <div className={styles['user-face-container']}>
                <Tooltip
                    placement="top"
                    containerOffsetY={this.getOffsetY()}
                    title={lockInfo.user.name}
                    overlayStyle={{ whiteSpace: 'normal', maxWidth: '100px' }}
                    disabled={!lockInfo.user.name}>
                    <img className={styles['user-face']} src={lockInfo.user.avatar || CUSTOM.IMAGE.DEFAULT_AVATAR} />
                </Tooltip>
            </div>
        );
    }
}

export default SlideListCell;
